import { render, staticRenderFns } from "./a22.vue?vue&type=template&id=02987cc9&scoped=true"
import script from "./a22.vue?vue&type=script&lang=js"
export * from "./a22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02987cc9",
  null
  
)

export default component.exports